import { inject, Injectable } from '@angular/core';
import { StatefulValue } from '../../../class/stateful-value.class';
import { AdminPortalFeaturesService } from '@workflow/ecp-shared/service/user/admin-portal-features.service';
import { StatefulService } from '@app/service/stateful.service';

// This service needs unit testing!
@Injectable({ providedIn: 'root' })
export class ProgressBarDataService {
  // Loan Group Display Name
  public loanGroupDisplayName: string;
  // #region StatefullValue instance
  private oaoProductName: StatefulValue;
  private olaProductName: StatefulValue;
  private loanGroupIcon: StatefulValue;
  private loanGroupNameState: StatefulValue;
  private loanProductNameState: StatefulValue;
  private requestedLoanAmountState: StatefulValue;
  private loanTermState: StatefulValue;
  private downPaymentState: StatefulValue;
  private loanPurposeState: StatefulValue;

  public statefulService = inject(StatefulService);

  /**
   * Set stateful values
   *  @returns void
   */
  public setStateFulValues(): void {
    this.oaoProductName = this.statefulService.wrap('api:oaoMemberInformation/membership/membershipName');
    this.olaProductName = this.statefulService.wrap('ola:olaApplicationInformation/loanGroupName');
    this.loanGroupIcon = this.statefulService.wrap('ola:olaApplicationInformation/loanGroupIcon');
    this.loanGroupNameState = this.statefulService.wrap('ola:olaApplicationInformation/loanGroupName');
    this.loanProductNameState = this.statefulService.wrap('ola:olaApplicationInformation/loanProductName');
    this.requestedLoanAmountState = this.statefulService.wrap('ola:olaApplicationInformation/financing/requestedLoanAmount');
    this.loanTermState = this.statefulService.wrap('ola:olaApplicationInformation/financing/loanTerm');
    this.downPaymentState = this.statefulService.wrap('ola:olaApplicationInformation/financing/downPayment');
    this.loanPurposeState = this.statefulService.wrap('ola:olaApplicationInformation/loanPurposeType');
  }
  // #endregion

  constructor(protected readonly adminFeaturesService: AdminPortalFeaturesService) {}

  private calculatedPercent = 0;
  public flowType: 'OLA' | 'OAO';
  public get productName(): string {
    if (this.flowType === 'OLA') {
      return this.olaProductName.valueStringOnly;
    } else {
      return this.oaoProductName.valueStringOnly;
    }
  }

  public CalculatePercentage(progress: number): number {
    const percent = (Math.floor(progress / 5) + 1) * 5;

    if (this.calculatedPercent > percent) return this.calculatedPercent;
    else if (percent === 100) this.calculatedPercent = 95;
    else this.calculatedPercent = percent;
    return this.calculatedPercent;
  }

  public RefreshProgressData(): void {
    /// Since progress will never decrease once increased resetting
    /// the percentage for new app created from dashboard
    this.calculatedPercent = 0;
  }

  /**
   * Set Loan Group Display Name
   */
  public SetLoanGroupDisplayName() {
    this.loanGroupDisplayName = this.loanGroupName;
    const consumerLoanGroups = this.adminFeaturesService?.config?.olaConfiguration?.consumerLoanGroups?.filter(
      (t) => t.isActive && !t.hideInUI
    );
    const loanGroup = consumerLoanGroups?.filter((f) => f.loanGroup?.toLowerCase() === this.loanGroupName?.toLowerCase());
    if (loanGroup && loanGroup.length > 0) {
      this.loanGroupDisplayName = loanGroup[0].displayName;
    }
  }
  public get loanGroupName(): string {
    return this.loanGroupNameState.valueString;
  }
  public get loanProductName(): string {
    return this.loanProductNameState.valueString;
  }
  public get requestedLoanAmount(): string {
    return this.requestedLoanAmountState.valid && this.requestedLoanAmountState.valueString;
  }
  public get loanTerm(): string {
    return this.loanTermState.valid && this.loanTermState.valueString;
  }
  public get downPayment(): string {
    return this.downPaymentState.valid && this.downPaymentState.valueString;
  }
  public get loanPurpose(): string {
    return this.loanPurposeState.valid && this.loanPurposeState.valueString;
  }

  public get groupIcon(): string {
    return (this.flowType === 'OLA' && this.loanGroupIcon.valid && this.loanGroupIcon.valueString) || null;
  }

  public get isDataAvailable(): boolean {
    return this.flowType === 'OLA' && (!!this.requestedLoanAmount || !!this.loanTerm || !!this.downPayment || !!this.loanPurpose);
  }
}
